import { useTranslation } from 'react-i18next'

import { usePageBrowserTabTitle } from '../../../hooks'
import { Auth } from '../Auth'
import { useAuthValidateHash } from '../Auth.hooks'

import { CreatePasswordForm } from './CreatePasswordForm'

function CreatePassword({ onValidateHash, ...restProps }) {
  const { t } = useTranslation()

  usePageBrowserTabTitle({
    pageTitle: t('BrowserTab.CreatePasswordPageTitleKey'),
  })

  const { isValidHash, loading } = useAuthValidateHash({
    onValidate: onValidateHash,
  })

  return (
    <Auth loading={loading}>
      <CreatePasswordForm {...restProps} isValidHash={isValidHash} />
    </Auth>
  )
}

export default CreatePassword
